import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=853a9d6e&scoped=true&"
import script from "./NavigationTab.vue?vue&type=script&lang=ts&"
export * from "./NavigationTab.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationTab.vue?vue&type=style&index=0&id=853a9d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a9d6e",
  null
  
)

export default component.exports